import { ImageProps, ChakraComponent } from '@chakra-ui/react';
import { Image } from 'src/theme';
import DefaultAvatarImage from 'src/theme/dss-skeleton/themes/assets/png/defaultAvatar.png';

type ImageComponent = ChakraComponent<'img', {}>;

export const DefaultAvatar = ((props: ImageProps) => {
  return <Image {...props} alt='default_avatar' src={DefaultAvatarImage.src} />;
}) as ImageComponent;
